import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icons/dingbu.png';
const _withScopeId = n => (_pushScopeId("data-v-be88f216"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_1"
};
const _hoisted_2 = {
  key: 0,
  class: "abop_s_a"
};
const _hoisted_3 = {
  key: 1,
  class: "protos"
};
import { ref, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import protoPagination from "@/components/proto-pagination.vue";
import { get_chart_cont, getgroup_cont } from "@/service/modules/alllist";
import item_I from "./item.vue";
import useRoleStore from "@/store/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'allchat',
  props: {
    types: {
      type: Number,
      default: 1
    },
    cha_id: {
      type: String,
      default: ""
    },
    activeName: {
      type: Number,
      default: 1
    },
    selectedDateRange: {
      type: Array,
      default: []
    },
    from: {
      type: String,
      default: ""
    },
    page_f: {
      type: Number,
      default: 1
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const roleStore = useRoleStore();
    const props = __props;
    const page = ref({
      page: props.page_f,
      pageSize: 50
    });
    const roleListTotal = ref(0);
    const loading = ref(false);
    const data_list = ref([]);
    const msgtype = ref("");
    const scrollContainer = ref(null);
    // 用于控制“返回顶部”按钮的可见性
    const showScrollToTopButton = ref(false);
    const go_scolls = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollTop = 0; // 滚动到顶部
      }
    };
    // 检查当前滚动位置
    const checkScrollPosition = () => {
      if (scrollContainer.value) {
        showScrollToTopButton.value = scrollContainer.value.scrollTop > 0;
      }
    };
    watch(() => props.cha_id, newValue => {
      if (newValue) {
        page.value.page = props.page_f;
        // get_list();
      } else {
        data_list.value = [];
      }
    });
    watch(() => props.selectedDateRange, newValue => {
      page.value.page = props.page_f;
      get_list();
    });
    watch(() => props.activeName, newValue => {
      page.value.page = props.page_f;
      if (newValue === 1) {
        msgtype.value = "";
      } else if (newValue === 2) {
        msgtype.value = "image,video";
      } else if (newValue === 3) {
        msgtype.value = "file";
      } else if (newValue === 4) {
        msgtype.value = "link";
      } else if (newValue === 5) {
        msgtype.value = "voice";
      }
      get_list();
    });
    const get_list = async () => {
      roleStore.setLoading(true);
      loading.value = true;
      try {
        let res;
        if (props.types == 1) {
          res = await get_chart_cont({
            md5: props.cha_id,
            userid: props.from,
            page: page.value.page,
            pageSize: page.value.pageSize,
            msgtype: msgtype.value,
            begin_time: props.selectedDateRange.length > 0 ? props.selectedDateRange[0] : "",
            end_time: props.selectedDateRange.length > 0 ? props.selectedDateRange[1] : ""
          });
        } else if (props.types == 2) {
          res = await getgroup_cont({
            chat_id: props.cha_id,
            page: page.value.page,
            pageSize: page.value.pageSize,
            msgtype: msgtype.value,
            begin_time: props.selectedDateRange.length > 0 ? props.selectedDateRange[0] : "",
            end_time: props.selectedDateRange.length > 0 ? props.selectedDateRange[1] : ""
          });
        }
        if (res && res.code == 0) {
          data_list.value = res.data.data.reverse();
          roleListTotal.value = res.data.total;
        } else {
          console.error("请求失败:", res.message);
        }
      } catch (error) {
        console.error("请求错误:", error);
      } finally {
        loading.value = false;
        roleStore.setLoading(false);
      }
    };
    function handleRoleTableCurrentChange(val) {
      page.value.page = val;
      get_list();
    }
    watch(data_list, async () => {
      await nextTick();
      scrollToBottom();
    });
    const scrollToBottom = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
      }
    };
    onMounted(() => {
      if (scrollContainer.value) {
        scrollContainer.value.addEventListener('scroll', checkScrollPosition);
      }
      if (props?.cha_id) {
        get_list();
      } else {
        data_list.value = [];
      }
    });
    onBeforeUnmount(() => {
      if (scrollContainer.value) {
        scrollContainer.value.removeEventListener('scroll', checkScrollPosition);
      }
    });
    // 导出方法以便在其他地方使用
    __expose({
      get_list
    });
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "box_ops",
        ref_key: "scrollContainer",
        ref: scrollContainer
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_list.value, (item, index) => {
        return _openBlock(), _createBlock(item_I, {
          items: item,
          key: index,
          from: __props.from,
          types: __props.types,
          index: index
        }, null, 8, ["items", "from", "types", "index"]);
      }), 128))], 512), showScrollToTopButton.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        class: "icon_dingbu",
        onClick: go_scolls,
        src: _imports_0,
        alt: "Scroll to top"
      })])) : _createCommentVNode("", true), roleListTotal.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(protoPagination, {
        page: page.value,
        total: roleListTotal.value,
        onCurrentChange: handleRoleTableCurrentChange
      }, null, 8, ["page", "total"])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]);
    };
  }
});